import phoneMask from '../phoneMask'

/**
 * The phone input's own scope, holding libphonenumber once it arrives. The library is a chunk of
 * its own, fetched the first time somebody types a country code that is not +1 — which on a US
 * Medicare programme is close to nobody, so the landing page itself never carries the weight.
 *
 * Keeping the formatter on Alpine state rather than in the module is deliberate: the mask reads it
 * while it is still null, so Alpine re-runs the mask the moment the chunk lands and the number
 * groups itself right then, instead of sitting unformatted until the next keystroke.
 */
export default () => ({
    asYouType: null,

    phoneMask(value) {
        if (this.asYouType === null && /^\+[2-9]/.test(value)) {
            import('../asYouType').then(loaded => {
                this.asYouType = loaded.AsYouType
            })
        }

        return phoneMask(value, this.asYouType)
    },
})
